import React from "react";
import {TimeField} from "../../cms/form-components/TimeField";
import {useTranslation} from "react-i18next";
import {
    Available,
    Wrapper,
    Label,
    TimeFieldWrapper,
    TimeFieldLabel,
    ClosedLabel,
    TimeFieldsContainer
} from "./DayOpeningHoursRow.style";
import {LogicalToggleField} from "../../cms/form-components/LogicalToggleField";
import {useWindowWidth} from "../../../../hooks/useWindowWidth";

export const DayOpeningHoursRow = ({
                                       operatingHours,
                                       objKey,
                                       availableHandler,
                                       openingTimeHandler,
                                       closingTimeHandler
                                   }) => {
    const {t} = useTranslation();
    const lowerKey = objKey?.toLowerCase();
    const windowWidth = useWindowWidth();
    const isMobile = windowWidth <= 600;

    const wrapperGrid = isMobile ?
        {gridTemplateColumns: '50px auto max-content'} :
        {gridTemplateColumns: '50px 150px max-content'}


    const renderTimeFields = () => {
        if (!operatingHours?.[objKey]?.available) {
            return (<ClosedLabel>{t('closed')}</ClosedLabel>);
        }
        return (
            <TimeFieldsContainer>
                <TimeFieldWrapper>
                    <TimeFieldLabel>{t('timeFrom')}</TimeFieldLabel>
                    <TimeField id={`${lowerKey}OpeningTime`}
                               name={`${lowerKey}OpeningTime`}
                               value={operatingHours?.[objKey]?.startTime}
                               onChange={openingTimeHandler}
                    />
                </TimeFieldWrapper>
                <TimeFieldWrapper>
                    <TimeFieldLabel>{t('timeTo')}</TimeFieldLabel>
                    <TimeField id={`${lowerKey}OpeningTime`}
                               name={`${lowerKey}ClosingTime`}
                               value={operatingHours?.[objKey]?.endTime}
                               onChange={closingTimeHandler}
                    />
                </TimeFieldWrapper>
            </TimeFieldsContainer>
        );
    }

    return (
        <Wrapper style={wrapperGrid}>
            <Available>
                <LogicalToggleField id={`${lowerKey}Available`}
                                    value={operatingHours?.[objKey]?.available}
                                    onChange={availableHandler}
                                    disableDescriptions={true}
                                    containerStyle={{marginBottom: '0'}}/>
            </Available>
            <Label>{isMobile ? String(t(lowerKey)).substring(0, 3) : t(lowerKey)}</Label>
            {renderTimeFields()}
        </Wrapper>
    );
}